import { localStorageToken } from "@/tokens";
import { CommonModule } from "@modules/common_module/CommonModule";
import type LocationControllerInterface from "@modules/common_module/LocationController/LocationControllerInterface";
import { lastValueFrom } from "rxjs";
import { inject, singleton } from "tsyringe";

import RewardsReferralContextApiService from "../api_services/RewardsReferralContextApiService";
import {
    REFERRAL_CONTEXT_SEARCH_PARAM,
    REFERRAL_CONTEXT_STORAGE_KEY,
} from "../constants/constants";

@singleton()
class RewardsReferralContextService {
    private readonly locationController: LocationControllerInterface;

    constructor(
        @inject(localStorageToken)
        private readonly storage: Storage,
        private readonly commonModule: CommonModule,
        private readonly rewardsReferralContextApiService: RewardsReferralContextApiService
    ) {
        this.locationController = this.commonModule.exports.locationController;
    }

    private getReferralContextFromStorage(): string | null {
        return this.storage.getItem(REFERRAL_CONTEXT_STORAGE_KEY);
    }

    private getReferralContextFromSearchParams(): string | null {
        const searchParams = this.locationController.getSearchParams();

        return searchParams.get(REFERRAL_CONTEXT_SEARCH_PARAM);
    }

    public getReferralContext(): string | null {
        return (
            this.getReferralContextFromStorage() ||
            this.getReferralContextFromSearchParams()
        );
    }

    public removeReferralContextFromStorage(): void {
        this.storage.removeItem(REFERRAL_CONTEXT_STORAGE_KEY);
    }

    public async setReferralContext(referralContext: string): Promise<void> {
        await lastValueFrom(
            this.rewardsReferralContextApiService.setReferralContext({
                referralContext,
            })
        );
    }
}

export default RewardsReferralContextService;
